<template>
    <b-sidebar
     id="cat-form-sidebar"
     :visible="isCatFormSidebarActive"
     bg-variant="white"
     sidebar-class="sidebar-lg"
     shadow
     backdrop
     no-header
     right
     @shown="getData(categoryData)"
     @hidden="resetForm(resetData)"
     @change="(val) => $emit('update:is-cat-form-sidebar-active', val)"
   >
   <template #default="{ hide }"> 
       <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
           <h5 class="mb-0">
               Blog Category Form
           </h5>
   
           <feather-icon
               class="ml-1 cursor-pointer"
               icon="XIcon"
               size="16"
               @click="hide"
           />
       </div>
       <validation-observer
         #default="{ handleSubmit }"
         ref="refFormObserver"
       >
         <b-form
           class="p-2"
           @submit.prevent="handleSubmit(onSubmit)"
           @reset.prevent="resetForm"
         >
         <validation-provider
             #default="validationContext"
             name="Title"
             rules="required"
           >
             <b-form-group
               label="Title"
               label-for="title"
             >
               <b-form-input
                 id="title"
                 v-model="Data.title"
                 autofocus
                 :state="getValidationState(validationContext)"
                 trim
                 placeholder="Title"
                 @input="changeTitle"
               />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
           <validation-provider
             #default="validationContext"
             name="slug"
             rules="required"
           >
             <b-form-group
               label="Slug"
               label-for="slug"
             >
               <b-form-input
                 id="slug"
                 v-model="Data.slug"
                 autofocus
                 :state="getValidationState(validationContext)"
                 trim
                 placeholder="Slug"
               />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
           
           <!--<validation-provider
             #default="validationContext"
             name="short_text"
             rules="required"
           >
             <b-form-group
               label="short_text"
               label-for="short_text"
             >
               <b-form-input
                 id="short_text"
                 v-model="Data.short_text"
                 autofocus
                 :state="getValidationState(validationContext)"
                 trim
                 placeholder="short text"
               />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
          -->
            <div class="border rounded p-2 mb-2">
              <h4 class="mb-1">
                Cover Image
              </h4>
              <b-media
                no-body
                vertical-align="center"
                class="flex-column flex-md-row"
              >
                <b-media-aside>
                  <b-img
                    ref="refCoverEl"
                    :src="Data.coverImage"
                    height="110"
                    width="170"
                    class="rounded mr-2 mb-1 mb-md-0"
                  />
                </b-media-aside>
                <b-media-body>
                  <small class="text-muted">Required image resolution 1940x540, image size 10mb.</small>
                  <b-card-text class="my-50">
                   
                  </b-card-text>
                  <div class="d-inline-block">
                    <b-form-file
                      ref="refInputCoverEl"
                      v-model="Data.coverFile"
                      accept=".jpg, .png, .gif, .webp,"
                      placeholder="Choose file"
                      @input="inputImageRenderer"
                    />
                  </div>
                  <b-card-text class="my-50">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.cover_image" @click="revomeCover">Remove Image</b-button>
                  </b-card-text>
                </b-media-body>
              </b-media>
            </div>
            <div class="border rounded p-2">
              <h4 class="mb-1">
                Banner Image
              </h4>
              <b-media
                no-body
                vertical-align="center"
                class="flex-column flex-md-row"
              >
                <b-media-aside>
                  <b-img
                    ref="refPreviewEl"
                    :src="Data.bannerImage"
                    height="110"
                    width="170"
                    class="rounded mr-2 mb-1 mb-md-0"
                  />
                </b-media-aside>
                <b-media-body>
                  <small class="text-muted">Required image resolution 312x312, image size 3mb.</small>
                  <b-card-text class="my-50">
                   
                  </b-card-text>
                  <div class="d-inline-block">
                    <b-form-file
                      ref="refInputEl"
                      v-model="Data.bannerFile"
                      accept=".jpg, .png, .gif, .webp,"
                      placeholder="Choose file"
                      @input="inputBannerRenderer"
                    />
                  </div>
                  <b-card-text class="my-50">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" v-if="Data.banner_image" @click="revomeBanner">Remove Image</b-button>
                  </b-card-text>
                </b-media-body>
              </b-media>
            </div>
            
                    
           <validation-provider
             #default="validationContext"
             name="IsActive"
             rules="min:0"
           >
             <b-form-group
               label="Is Active"
               label-for="IsActive"
             >
             
               <b-form-checkbox
               id="isactive"
                               checked="true"
                               class="custom-control-success"
                               v-model="Data.is_active"
                               switch
                 />
 
               <b-form-invalid-feedback>
                 {{ validationContext.errors[0] }}
               </b-form-invalid-feedback>
             </b-form-group>
           </validation-provider>
           <div class="d-flex mt-2">
             <b-button
               v-ripple.400="'rgba(255, 255, 255, 0.15)'"
               variant="primary"
               class="mr-2"
               type="submit"
             >
               Submit
             </b-button>
             <b-button
               v-ripple.400="'rgba(186, 191, 199, 0.15)'"
               type="button"
               variant="outline-secondary"
               @click="hide"
             >
               Cancel
             </b-button>
           </div>
         </b-form>
         
         
       </validation-observer>
   </template>
   </b-sidebar>
</template>
<script>
 import {
   BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,BMedia,BMediaAside,
   BMediaBody,BCard,BCardText,BFormFile,BImg,
 } from 'bootstrap-vue'
 import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
 import { ValidationProvider, ValidationObserver } from 'vee-validate'
 import { ref } from '@vue/composition-api'
 import { required, alphaNum, email, password,confirmed } from '@validations'
 import formValidation from '@core/comp-functions/forms/form-validation'
 import Ripple from 'vue-ripple-directive'
 import vSelect from 'vue-select'
 import countries from '@/@fake-db/data/other/countries'
 import store from '@/store'
 import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
 import { useToast } from 'vue-toastification/composition'
 import { slugify } from '@/@fake-db/utils'
export default {
   components: {
     BMedia,
     BMediaBody,
     BMediaAside,
     BFormFile,
     BSidebar,
     BImg,
     BCard,
     BCardText,
     BForm,
     BFormGroup,
     BFormInput,
     BFormCheckbox,
     BFormInvalidFeedback,
     BButton,
     vSelect,
 
     // Form Validation
     ValidationProvider,
     ValidationObserver,
   },
   directives: {
     Ripple,
   },
   model: {
     prop: 'isCatFormSidebarActive',
     event: 'update:is-cat-form-sidebar-active',
   },
   props: {
     isCatFormSidebarActive: {
       type: Boolean,
       required: true,
     },
    
     categoryData: {
       type: Object,
       required: false,
     },
   },
   
   setup(props, { emit }) {
       const toast = useToast()
       const catData = ref([]);
       const userStorage = JSON.parse(localStorage.getItem('userData'));
       const getLocalSite = JSON.parse(localStorage.getItem('site'))
       const blankData = {
           coverImage:require('@/assets/images/no-image.png'),
           bannerImage:require('@/assets/images/no-image.png'),
           created_by:userStorage.id,
           created_at:null,
           title: '',
           slug:'',
           short_text:'',
           cover_image:'',
           banner_image:'',
           is_active:true,
           parent:0,
           ordering_count:0,
           sites_id: getLocalSite.id
       }
       const Data = ref(JSON.parse(JSON.stringify(blankData)))
       const resetData = () => {
           Data.value = JSON.parse(JSON.stringify(blankData))
       }
       const getData = (data)=>{
        refCoverEl.value.src = require('@/assets/images/no-image.png');
        refPreviewEl.value.src = require('@/assets/images/no-image.png');
         
           if(data){
                data.coverImage = data.cover_image?data.fullpath:Data.value.coverImage;
                data.bannerImage = data.banner_image?data.fullbannerpath:Data.value.bannerImage;

               data.is_active = data.is_active===1?true:false;
               Data.value  = JSON.parse(JSON.stringify(data));
           }else{
             Data.value = JSON.parse(JSON.stringify(blankData))
           }
       }
      
       const onSubmit = () => {
            let formData = new FormData();
            Data.value.is_active = Data.value.is_active?1:0;
            Data.value.path = '/var/www/html/uploadfiles/uploads/zip/socials/';
            Data.value.savepath = 'uploads/zip/socials/';
            for(const [key, value] of Object.entries(Data.value)) {
              formData.append(key, value);          
            }

           if(Data.value.id){
               
               store.dispatch('app-socials/updateCategory', {formData:formData,data:Data.value})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-cat-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }else{
               store.dispatch('app-socials/addCategory', {formData:formData})
               .then((res) => {
                   
                   if(res.data.success){
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Success`,
                       icon: 'BellIcon',
                       variant: 'success',
                       text: `${res.data.message}`,
                       },
                   });
                   emit('refetch-data')
                   emit('update:is-cat-form-sidebar-active', false)
                   }else{
                   
                   toast({
                       component: ToastificationContent,
                       position: 'top-right',
                       props: {
                       title: `Error`,
                       icon: 'BellIcon',
                       variant: 'danger',
                       text: `${res.data.message}`,
                       },
                   });
               
                   
                   }
               
               })
           }

       }
       
        const {
       refFormObserver,
       getValidationState,
       resetForm,
     } = formValidation(resetData)

     //upload
     const refInputEl = ref(null)
      const refPreviewEl = ref(null)

      
     const { inputBannerRenderer } = useInputImageRenderer(refInputEl, base64 => { 
        refPreviewEl.value.src = base64 
     })

      const refInputCoverEl = ref(null);
     const refCoverEl = ref(null)
              
     const { inputImageRenderer } = useInputImageRenderer(refInputCoverEl, base64 => { 
     
      refCoverEl.value.src = base64 
    })


       const revomeBanner = ()=>{
      Data.value.bannerImage = require('@/assets/images/no-image.png');
      Data.value.banner_image = '';
     }
     const revomeCover = ()=>{
      Data.value.coverImage = require('@/assets/images/no-image.png');
      Data.value.cover_image = '';
     }

     const changeTitle  = () => {
        Data.value.slug =  slugify(Data.value.title )
    }

     return {

       refInputEl,
       refPreviewEl,
       inputImageRenderer,
       refInputCoverEl,
       refCoverEl,
       inputBannerRenderer,
       revomeCover,
       revomeBanner,
       Data,
       onSubmit,
       catData,
       refFormObserver,
       getValidationState,
       resetForm,
       resetData,
       getData,
       changeTitle
     }
  
   }
   
}
</script>